export namespace LayoutsConfig {
    export const allowedCssProperties = [
        "background",
        "border",
        "border-radius",
        "color",
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "letter-spacing",
        "padding",
        "text-decoration",
        "text-transform",
    ] as const;
}
